export var provideAdaUserData = function provideAdaUserData(user) {
  if (!user) {
    return;
  }
  window.adaSettings = {
    metaFields: {
      name: user.fullName,
      uuid: user.identity,
      email: user.email
    }
  };
};
export default provideAdaUserData;